import { Object3D } from "three";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class BoxDeathParticle extends Object3D {
    private particles: Object3D;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer
    ) {
        super();
        this.particles = clone(this.gameResources.assets_game_particles_box_death_thjson);
        QuarksUtil.setAutoDestroy(this.particles, true);
        QuarksUtil.addToBatchRenderer(this.particles, this.particlesRenderer);
        this.add(this.particles);
    }

    public async play(): Promise<void> {
        QuarksUtil.play(this.particles);
        await this.waitForEffect(this.particles);
    }

    private async waitForEffect(effect: Object3D): Promise<void> {
        return new Promise<void>((resolve) => {
            const check = () => {
                if (effect.children.length === 0) {
                    resolve();
                } else {
                    requestAnimationFrame(check);
                }
            };
            check();
        });
    }
}


